module.exports = __webpack_public_path__ + "static/media/popup_home_190722.b9d403a8.svg";